import { render, staticRenderFns } from "./approval-process.vue?vue&type=template&id=636ad3f0&scoped=true&"
import script from "./approval-process.vue?vue&type=script&lang=js&"
export * from "./approval-process.vue?vue&type=script&lang=js&"
import style0 from "./approval-process.vue?vue&type=style&index=0&id=636ad3f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636ad3f0",
  null
  
)

export default component.exports